import TreeSystemPrototypeApp from '../../components/3d/tree-system/App.jsx';

/**
 * Route nur zum Ansehen des ursprünglichen Tree-System-Prototyps (App.jsx).
 * URL: /tree-system-app
 */
export default function TreeSystemAppDemoPage() {
  return <TreeSystemPrototypeApp />;
}
